module.exports = __webpack_public_path__ + "img/KnowledgeInjection.3da31c65.svg";